import { useSnackbar } from 'notistack';
import React from 'react';
import NetworkConnectionContext from './network-connection.context';


export default function NetworkConnectionProvider({ children }) {
  const notificationKey = React.useRef(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [connectionState, setConnectionState] = React.useState({
    isConnected: true,
    setIsConnected: (isConnected) => setConnectionState(prev => ({ ...prev, isConnected }))
  });


  React.useEffect(() => {
    onConnectionChange();
    window.addEventListener('online', onConnectionChange);
    window.addEventListener('offline', onConnectionChange);

    return () => {
      window.removeEventListener('online', onConnectionChange);
      window.removeEventListener('offline', onConnectionChange);
    }
  }, []);


  const onConnectionChange = () => {
    if (window.navigator.onLine) {
      // ping google
      fetch('https://www.google.com/', { mode: 'no-cors' })
        .then(() =>  setConnectionState(prev => ({ ...prev, isConnected: true })))
        .catch(() => setConnectionState(prev => ({ ...prev, isConnected: false })));
      
      return;
    }

    setConnectionState(prev => ({ ...prev, isConnected: false }));
  }


  React.useLayoutEffect(() => {
    if (!connectionState.isConnected) {
      notificationKey.current = enqueueSnackbar('Network connection lost', {
        variant: "error",
        key: notificationKey.current,
        persist: true,
        preventDuplicate: true,
        transitionDuration: 1000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "center"
        },
      })
    } else {
      if (notificationKey.current) {
        closeSnackbar(notificationKey.current);
        notificationKey.current = null;
      }
    }
  }, [connectionState.isConnected, enqueueSnackbar, closeSnackbar]);


  return (
    <NetworkConnectionContext.Provider value={connectionState}>
      { children }
    </NetworkConnectionContext.Provider>
  );
}